/* ••[1]••••••••••••••••••••••••• carousel.ts •••••••••••••••••••••••••••••• */

import "./carouselLogic.min.js";

class Carousel {
  constructor(private $carouselWrapper: HTMLElement) {
    // @ts-ignore
    return new SumCarousel(this.$carouselWrapper, {
      adaptiveHeight: true,
      autoPlay: 4500,
      cellAlign: "center",
      draggable: true,
      dragThreshold: 10,
      lazyLoad: 2,
      pageDots: true,
      pauseAutoPlayOnHover: true,
      prevNextButtons: true,
      wrapAround: true,
    });
  }
}

export default Carousel;
